<!--
<div >
  <div class="top-controls" [ngClass]="{'showcase-container': showcase === true}">
    <h1>{{title}}</h1>
  </div>

  <div class="horizontal-layout items" *ngIf="!loading; else skeleton" [ngClass]="{'showcase-container': showcase === true}">
    <div *ngFor="let item of items.slice(0, amount); let j = index">
      <div class="recommended-item" *ngIf="mode==1">
        <app-recording-snappenin-item [ngClass]="{'showcase-container': showcase === true}" [item]="items[j]" [showStats]="showStats" title="Song: {{item.song.title}}&#013;Artist: {{item.song.artist_name}}"></app-recording-snappenin-item>
      </div>
      <div class="recommended-item" *ngIf="mode==2">
        <app-featured-image [item]="items[j]" [showStats]="showStats"></app-featured-image>
      </div>
    </div>
  </div>


  <ng-template  #skeleton>
    <div class="horizontal-layout items"  style="padding-left: 15px; height: 264px;">
      <div *ngFor="let e of [].constructor(6)">
        <div class = "snappenin-item-image skeleton">
          <div class = "snappenin-item-line1 skeleton"></div>
          <div class = "snappenin-item-line2 skeleton"></div>
          <div class = "snappenin-item-line3 skeleton"></div>
        </div>
      </div>
    </div>
  </ng-template>
  <a href="#/d/{{pageType}}" style='color: #58c7c9; bottom:0; ' class="featured-list--more" >See More</a>
</div>
   -->

 <div>
  <div class="top-controls" [ngClass]="{'showcase-container': showcase === true}">
    <h1>{{title}}</h1>
      <button *ngIf="showcase" class="showcase-toggle-btn" (click)="toggleExpand()" [title]="expanded ? 'Show Less' : 'Show All'">
        <svg viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="btnGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style="stop-color:#c084fc"/>
              <stop offset="100%" style="stop-color:#818cf8"/>
            </linearGradient>
          </defs>
          <!-- Rotates 90deg when expanded to point down as "collapse" indicator -->
          <polygon
            [attr.transform]="expanded ? 'rotate(90, 30, 30)' : 'rotate(0, 30, 30)'"
            points="15,10 50,30 15,50"
            fill="url(#btnGradient)"
            style="transition: transform 0.3s ease;"
          />
        </svg>
      </button>
  </div>

  <div class="horizontal-layout items"
       *ngIf="!loading; else skeleton"
        [ngClass]="{
          'showcase-layout': showcase === true ,
          'showcase-expanded-grid': showcase === true && expanded
        }">
    <div *ngFor="let item of items.slice(0, amount); let j = index">
      <!-- <div class="recommended-item" *ngIf="mode==1"> -->
      <div class="recommended-item" *ngIf="mode==1">
        <app-recording-snappenin-item

          [item]="items[j]"
          [showStats]="showStats"
          title="Song: {{item.song.title}}&#013;Artist: {{item.song.artist_name}}">
        </app-recording-snappenin-item>
      </div>
      <div class="recommended-item" *ngIf="mode==2">
        <app-featured-image [item]="items[j]" [showStats]="showStats"></app-featured-image>
      </div>
    </div>
  </div>

  <ng-template #skeleton>
    <div class="horizontal-layout items" style="padding-left: 15px; height: 264px;">
      <div *ngFor="let e of [].constructor(6)">
        <div class="snappenin-item-image skeleton">
          <div class="snappenin-item-line1 skeleton"></div>
          <div class="snappenin-item-line2 skeleton"></div>
          <div class="snappenin-item-line3 skeleton"></div>
        </div>
      </div>
    </div>
  </ng-template>

  <div *ngIf="showcase" style="text-align: center; margin: 10px 0 4px;">
    <button class="showcase-collapse-btn" (click)="toggleExpand()">
      {{ expanded ? 'Show Less' : 'Show All Showcases' }}
    </button>
  </div>

  <a *ngIf="!showcase" href="#/d/{{pageType}}" style='color: #58c7c9; bottom:0;' class="featured-list--more">See More</a>
</div>

